import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const CancelButtonWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  .continue-test-button {
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    border: 1px solid ${({ theme: { token } }) => token.colorBorder};
    padding-right: ${({ theme: { token } }) => token.paddingLG}px;
    padding-left: ${({ theme: { token } }) => token.padding}px;
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
  }

  .buttons-wrapper {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    width: 100%;

    .button-space {
      margin-left: 7px;
    }
  }

  .cancel-modal-title {
    color: ${({ theme: { token } }) => token.colorText};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }
  .cancel-modal-content {
    margin-top: 5px;
  }
`;
